import Icon from '../components/Icon.vue'

Icon.register({
  'transgender-alt': {
    width: 480,
    height: 512,
    paths: [
      {
        d: 'M468 0H389C378.3 0 373 12.9 380.5 20.5L397.4 37.4 316.7 118.1C294.5 104.1 268.2 96 240 96 211.8 96 185.5 104.1 163.3 118.1L146.8 101.6 166.6 81.8C171.3 77.1 171.3 69.5 166.6 64.8L138.3 36.5C133.6 31.8 126 31.8 121.3 36.5L101.5 56.3 82.5 37.3 99.4 20.4C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12V91C0 101.7 12.9 107 20.5 99.5L37.4 82.6 56.4 101.6 36.6 121.4C31.9 126.1 31.9 133.7 36.6 138.4L64.9 166.7C69.6 171.4 77.2 171.4 81.9 166.7L101.7 146.9 118.2 163.4C104.1 185.5 96 211.8 96 240 96 308.5 143.9 365.9 208 380.4V408H172C165.4 408 160 413.4 160 420V460C160 466.6 165.4 472 172 472H208V500C208 506.6 213.4 512 220 512H260C266.6 512 272 506.6 272 500V472H308C314.6 472 320 466.6 320 460V420C320 413.4 314.6 408 308 408H272V380.4C336.1 365.8 384 308.5 384 240 384 211.8 375.9 185.5 361.9 163.3L442.6 82.6 459.5 99.5C467.1 107.1 480 101.7 480 91V12C480 5.4 474.6 0 468 0zM240 320C195.9 320 160 284.1 160 240S195.9 160 240 160 320 195.9 320 240 284.1 320 240 320z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/transgender-alt.js
// module id = gXR8
// module chunks = 144